/* eslint-disable @typescript-eslint/no-explicit-any */

import { HTTPInstanceFastApi } from './http-instance-fastapi'

function getRestaurantId(): string {
  const id = localStorage.getItem('restaurantId')
  if (!id) {
    throw new Error('No restaurantId found in localStorage')
  }
  return id
}

function withRestaurantPrefix(path: string): string {
  return `/api/restaurants/${getRestaurantId()}${
    path.startsWith('/') ? path : `/${path}`
  }`
}

export const HTTPInstanceFastApiWithPrefix = {
  get: <T = any>(path: string, config?: any) =>
    HTTPInstanceFastApi.get<T>(withRestaurantPrefix(path), config),

  post: <T = any>(path: string, data?: any, config?: any) =>
    HTTPInstanceFastApi.post<T>(withRestaurantPrefix(path), data, config),

  put: <T = any>(path: string, data?: any, config?: any) =>
    HTTPInstanceFastApi.put<T>(withRestaurantPrefix(path), data, config),

  delete: <T = any>(path: string, config?: any) =>
    HTTPInstanceFastApi.delete<T>(withRestaurantPrefix(path), config)
}
